import React, { useMemo } from "react";
import { Select, TextField } from "@material-ui/core";

import cn from './styles.module.scss';

export const CARD_PAYMENT_CONFIG = {
  apasi_ccnumber: { key: 'apasi_ccnumber' },
  apasi_ccexpmonth: { key: 'apasi_ccexpmonth' },
  apasi_ccexpyear: { key: 'apasi_ccexpyear' },
  apasi_ccsecuritycode: { key: 'apasi_ccsecuritycode' },
};

const months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

export const CardPaymentForm = () => {
  const years = useMemo(() => {
    const array = Array(20).fill('');
    array[0] = new Date().getFullYear();
    return array.reduce((result, year, index) => {
      if (year) {
        return [...result, year];
      }
      if (index > 0 && result[index - 1]) {
        return [...result, result[index - 1] + 1];
      }
      return result;
    }, []);
  }, []);

  return (
    <div className={cn.cardPaymentForm}>
      <span className={cn.required}>Credit Card Number:</span>
      <TextField
        name={CARD_PAYMENT_CONFIG.apasi_ccnumber.key}
        variant="outlined"
        required
      />
      <span className={cn.required}>Expiration:</span>
      <div>
        <Select
          native
          variant="outlined"
          className={cn.shortInput}
          required
          name={CARD_PAYMENT_CONFIG.apasi_ccexpmonth.key}
        >
          {months.map((item) => (
            <option key={item} value={item}>{item}</option>
          ))}
        </Select>
        <Select
          native
          variant="outlined"
          className={cn.shortInput}
          required
          name={CARD_PAYMENT_CONFIG.apasi_ccexpyear.key}
        >
          {years.map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </Select>
      </div>
      <span className={cn.required}>CVV:</span>
      <TextField
        name={CARD_PAYMENT_CONFIG.apasi_ccsecuritycode.key}
        variant="outlined"
        className={cn.shortInput}
        required
      />
    </div>
  );
};
